import PropTypes from 'prop-types'
import React from 'react'
import Add from './add'

class Placeholder extends React.PureComponent {

  static propTypes = {
    answer: PropTypes.string,
    blocks: PropTypes.array,
    delta: PropTypes.number,
    editable: PropTypes.bool,
    hovering: PropTypes.object,
    parent: PropTypes.string,
    onAddStep: PropTypes.func,
    onHover: PropTypes.func,
    onNewStep: PropTypes.func
  }

  render() {
    return (
      <div className="flowchart-placeholder">
        <Add { ...this._getAdd() } />
      </div>
    )
  }

  _getAdd() {
    const { answer, blocks, delta, editable, parent, onAddStep, onNewStep } = this.props
    return {
      answer,
      blocks,
      delta,
      editable,
      parent,
      onAddStep,
      onNewStep
    }
  }

}

export default Placeholder
